import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Checkbox, Input } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ReportConfigurationModule, ReportConfigurationModuleField, ResourceType } from '@/schemas'

const prefixImgEnum = {
  '项目/组合': 'https://web-cdn.agora.io/pmo/icons/pp.png',
  目标: 'https://web-cdn.agora.io/pmo/icons/target.png',
  团队: 'https://web-cdn.agora.io/pmo/icons/team.png',
  客户项目: 'https://web-cdn.agora.io/pmo/icons/customer.png',
  产品项目: 'https://web-cdn.agora.io/pmo/icons/production.png',
  研发项目: 'https://web-cdn.agora.io/pmo/icons/devlop.png',
}

interface ReportConfigurationModuleFieldProps {
  selfId: string
  type: ResourceType
  field: ReportConfigurationModuleField
  module: ReportConfigurationModule
  refreshConfig: () => void
  canUpdate: boolean
  canDelete: boolean
}

export const ReportConfigurationModuleFieldContainer: React.FC<ReportConfigurationModuleFieldProps> = ({
  selfId,
  type,
  field,
  module,
  refreshConfig,
  canUpdate,
  canDelete,
}) => {
  const { t } = useTranslation()
  const [isSetName, setIsSetName] = React.useState(false)

  const { run: upsertModule } = useRequest(
    (data: ReportConfigurationModule) => ({
      url: '/api/report/upsertReportConfigModule',
      method: 'post',
      data: {
        selfId,
        type,
        ...data,
      },
    }),
    {
      manual: true,
      throwOnError: true,
      onSuccess: () => refreshConfig(),
    }
  )

  const changeFieldName = (value: string) => {
    if (value !== field.name) {
      upsertModule({
        ...module,
        fields: module.fields.map((f) => {
          if (f.id === field.id) {
            f.name = value
          }
          return f
        }),
      })
    }
    setIsSetName(false)
  }

  const changeFieldChecked = () => {
    upsertModule({
      ...module,
      fields: module.fields.map((f) => {
        if (f.id === field.id) {
          f.isChecked = !f.isChecked
        }
        return f
      }),
    })
  }

  const deleteField = () => {
    upsertModule({
      ...module,
      fields: module.fields.map((f) => {
        if (f.id === field.id) {
          f.isDeleted = true
        }
        return f
      }),
    })
  }

  return (
    <div className='flex bg-light-200 rounded-4px mx-8px py-6px px-10px justify-between items-center'>
      <div className='flex items-center'>
        {!module.isExtra && <img className='mr-5px' width={24} height={24} src={prefixImgEnum[field.name]} />}
        <Checkbox checked={field.isChecked} disabled={!canUpdate} onChange={() => changeFieldChecked()}>
          {!isSetName && t(field.name)}
        </Checkbox>
        {isSetName && (
          <Input
            autoFocus
            defaultValue={field.name}
            onBlur={(e) => changeFieldName(e.target.value)}
            onPressEnter={(e) => changeFieldName(e.target['value'])}
          />
        )}
        {!isSetName && (
          <>
            {field.isDefault && (
              <EditOutlined
                className={`${canUpdate ? 'cursor-pointer' : '!cursor-not-allowed'} ml-5px`}
                onClick={() => canUpdate && setIsSetName(true)}
              />
            )}
          </>
        )}
      </div>
      {field.isDefault && (
        <DeleteOutlined
          className={`${canDelete ? 'cursor-pointer' : '!cursor-not-allowed'} text-red-500`}
          onClick={() => canDelete && deleteField()}
        />
      )}
    </div>
  )
}
